module.exports = __webpack_public_path__ + "img/logo_4.02c2f9df.png";